module.exports = __webpack_public_path__ + "img/complex-simulation-icon-active.af549cf6.svg";